import VK from "./VK";
import { withVK } from "./VKContext";
import VKAllowMessagesFromCommunity from "./AllowMessagesFromCommunity";
import VKApplication from "./App";
import VKAuth from "./Auth";
import VKComments from "./Comments";
import VKCommentsBrowse from "./CommentsBrowse";
import VKCommunityMessages from "./CommunityMessages";
import VKContactUs from "./ContactUs";
import VKGroup from "./Group";
import VKLike from "./Like";
import VKPlaylist from "./Playlist";
import VKPoll from "./Poll";
import VKPost from "./Post";
import VKRecommended from "./Recommended";
import VKSubscribe from "./Subscribe";
import VKArticle from "./Article";
var AllowMessagesFromCommunity = withVK(VKAllowMessagesFromCommunity);
var Application = withVK(VKApplication);
var Auth = withVK(VKAuth);
var Comments = withVK(VKComments);
var CommentsBrowse = withVK(VKCommentsBrowse);
var CommunityMessages = withVK(VKCommunityMessages);
var ContactUs = withVK(VKContactUs);
var Group = withVK(VKGroup);
var Like = withVK(VKLike);
var Playlist = withVK(VKPlaylist);
var Poll = withVK(VKPoll);
var Post = withVK(VKPost);
var Recommended = withVK(VKRecommended);
var Subscribe = withVK(VKSubscribe);
var Article = withVK(VKArticle);
export default VK;
export { AllowMessagesFromCommunity, Application, Auth, Comments, CommentsBrowse, CommunityMessages, ContactUs, Group, Like, Playlist, Poll, Post, Recommended, Subscribe, Article };